import ApiService from "../../utils/fetch";

// TODO: Confirm ELM user management endpoints with the backend team
export const getElmUserList = async (applicationType) => {
  // Force a fresh fetch so post-edit refreshes don't get served a stale
  // cached response (browser/proxy HTTP cache) for the same URL+params.
  const response = await ApiService.get(
    `bottler/users`,
    { applicationType },
    { headers: { "Cache-Control": "no-cache", Pragma: "no-cache" } }
  );
  return response.data;
};

export const postInviteElmUser = async (payload) => {
  const response = await ApiService.post(`bottler/invite`, payload);
  return response.data;
};

export const deleteElmUser = async (payload) => {
  const response = await ApiService.delete(`bottler/delete`, payload);
  return response.data;
};

export const putEditElmUser = async (payload) => {
  const response = await ApiService.put(`bottler/update`, payload);
  return response.data;
};

export const getSupplierDropdownList = async (userEmail) => {
  const response = await ApiService.get(`api/v1/user/supplier/mapping`, { userEmail });
  return response.data;
};

export const getEmailDomainSuppliersList = async (email) => {
  const response = await ApiService.get(`api/v1/user/supplier/mapping/domain`, { email });
  return response.data;
};
